import { useEffect, useRef, useState } from 'react';
import { authConfigured, logout } from '../auth/cognito';
import { UserRound } from 'lucide-react';

export function ProfileMenu({ name, initials }: { name: string; initials: string }) {
  const [open, setOpen] = useState(false);
  const container = useRef<HTMLDivElement>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    const outside = (event: PointerEvent) => {
      if (!container.current?.contains(event.target as Node)) setOpen(false);
    };
    const escape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { setOpen(false); trigger.current?.focus(); }
    };
    document.addEventListener('pointerdown', outside);
    document.addEventListener('keydown', escape);
    return () => {
      document.removeEventListener('pointerdown', outside);
      document.removeEventListener('keydown', escape);
    };
  }, [open]);

  return (
    <div ref={container} className="relative" onBlur={(e) => {
      if (!e.currentTarget.contains(e.relatedTarget)) setOpen(false);
    }}>
      <button ref={trigger} type="button" aria-label={`Profile options for ${name}`} aria-expanded={open} aria-controls="profile-options"
        onClick={() => setOpen(!open)} title={name}
        className="flex h-[36px] w-[36px] items-center justify-center rounded-full text-[12px] font-bold"
        style={{ background: '#26262E', color: '#C8C8CC', border: '1px solid #3a3a44' }}>
        {initials || <UserRound size={18} aria-hidden="true" />}
      </button>
      {open && <div id="profile-options" aria-label="Profile options" className="absolute right-0 top-full mt-2 w-64 rounded-lg border border-panel bg-white p-2 text-code shadow-lg">
        <div className="break-words px-3 py-2 text-sm font-semibold">{name}</div>
        <button type="button" onClick={() => { setOpen(false); logout(); }} disabled={!authConfigured}
          className="w-full rounded px-3 py-2 text-left text-sm hover:bg-faint disabled:cursor-not-allowed disabled:opacity-50">Logout</button>
        {!authConfigured && <p className="px-3 text-xs text-storm">Sample mode: no account is signed in.</p>}
        <button type="button" disabled aria-describedby="delete-records-future" className="mt-1 w-full cursor-not-allowed rounded px-3 py-2 text-left text-sm text-storm">Delete all records</button>
        <p id="delete-records-future" className="px-3 pb-2 text-xs text-storm">Coming soon. Record deletion is not available here yet.</p>
      </div>}
    </div>
  );
}
